import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { getWidthScreen } from '/www/assets/src/react_additional_files/functions';
import { Button, CircularProgress, Backdrop, Typography, Fade, Slide, Grow, ListItemButton, ListItemText, ListItem, Stack, Box, Divider, IconButton, Drawer, List } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const App = () => {
    const [loader, setLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedRubric, setSelectedRubric] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        const handleRubricatorEvent = () => {
            toggleDrawer();
        };

        $(document).on('RubricatorHandler', handleRubricatorEvent);

        // Cleanup function
        return () => {
            $(document).off('RubricatorHandler', handleRubricatorEvent);
        };
    }, []);

    const showLoader = useCallback(() => {
        setLoader(true);
    }, []);

    const hideLoader = useCallback(() => {
        setLoader(false);
    }, []);

    const toggleDrawer = useCallback(() => {
        if (!open) {
            $('html').css({ overflow: 'hidden', 'padding-right': '16px' });
            setOpen(true);
        } else {
            $('html').css({ overflow: 'auto', padding: '0px' });
            setOpen(false);
            setSelectedRubric(false);
        }
    }, [open]);

    const getDrawerWidth = useCallback(() => {
        return getWidthScreen() === 'xl' || getWidthScreen() === 'lg' || getWidthScreen() === 'md' ? '500px' : '100vw';
    }, []);

    const rubricHandle = useCallback((rubric) => () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setSelectedRubric(rubric);
            setIsTransitioning(false);
        }, 150);
    }, []);

    const goTo = useCallback((url) => () => {
        showLoader();
        location.href = url;
    }, [showLoader]);

    const listGenerator = useCallback(() => {
        let result = [];
        let listItems = [];
        let vvi = 0;

        if (!selectedRubric) {
            // Main categories level
            for (const [key, value] of Object.entries(rubricator_json)) {
                listItems.push(
                    <Grow in={!isTransitioning} timeout={300 + parseInt(vvi) * 50} key={key}>
                        <ListItem
                            disablePadding
                            onClick={rubricHandle(value)}
                            secondaryAction={<KeyboardArrowRightIcon />}
                            sx={{
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    transform: 'translateX(4px)',
                                }
                            }}
                        >
                            <ListItemButton>
                                <ListItemText 
                                    primaryTypographyProps={{ sx: { fontSize: '16px' } }} 
                                    primary={value.name} 
                                />
                            </ListItemButton>
                        </ListItem>
                    </Grow>
                );
                vvi++;
            }
            result = (
                <Fade in={!isTransitioning} timeout={300}>
                    <div>
                        <List sx={{ 
                            transition: 'all 0.3s ease-in-out',
                            opacity: isTransitioning ? 0.5 : 1 
                        }}>
                            {listItems}
                        </List>
                        <Box sx={{ width: '100%', padding: '16px' }}>
                            <Button 
                                fullWidth 
                                size="large" 
                                variant="contained" 
                                onClick={goTo('/catalog')}
                                sx={{
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    }
                                }}
                            >
                                Все рубрики
                            </Button>
                        </Box>
                    </div>
                </Fade>
            );
        } else {
            // Subcategories level
            for (const [key, value] of Object.entries(selectedRubric.rubrics)) {
                listItems.push(
                    <Grow in={!isTransitioning} timeout={300 + parseInt(vvi) * 50} key={key}>
                        <ListItem
                            disablePadding
                            onClick={'rubrics' in value ? rubricHandle(value) : goTo(value.url)}
                            secondaryAction={'rubrics' in value ? <KeyboardArrowRightIcon /> : false}
                            sx={{
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    transform: 'translateX(4px)',
                                }
                            }}
                        >
                            <ListItemButton>
                                <ListItemText 
                                    primaryTypographyProps={{ sx: { fontSize: '16px' } }} 
                                    primary={value.name} 
                                />
                            </ListItemButton>
                        </ListItem>
                    </Grow>
                );
                vvi++;
            }

            let backRubric = false;
            let urlToRubric = false;

            if ('parent' in selectedRubric) {
                backRubric = rubricator_json[selectedRubric.kind][selectedRubric.parent];
            } else {
                backRubric = rubricator_json[selectedRubric.kind];
                urlToRubric = selectedRubric.url;
            }

            result = (
                <Fade in={!isTransitioning} timeout={300}>
                    <div>
                        <Box sx={{ width: '100%', padding: '16px' }}>
                            <Button
                                variant="text"
                                size="medium"
                                startIcon={<ArrowBackIcon />}
                                onClick={rubricHandle(backRubric)}
                                sx={{ 
                                    padding: '6px 0px', 
                                    marginBottom: '16px',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateX(-4px)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    }
                                }}
                            >
                                Назад
                            </Button>
                            <Typography 
                                variant="h4" 
                                display="block" 
                                gutterBottom
                                sx={{
                                    transition: 'all 0.3s ease-in-out',
                                    opacity: isTransitioning ? 0.7 : 1
                                }}
                            >
                                {selectedRubric.name}
                            </Typography>
                            {'kind' in selectedRubric ? (
                                <Button
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    onClick={goTo(selectedRubric.url)}
                                    sx={{
                                        transition: 'all 0.3s ease-in-out',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                        }
                                    }}
                                >
                                    Все товары рубрики
                                </Button>
                            ) : (
                                <Button 
                                    fullWidth 
                                    size="large" 
                                    variant="contained" 
                                    onClick={goTo(urlToRubric)}
                                    sx={{
                                        transition: 'all 0.3s ease-in-out',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                        }
                                    }}
                                >
                                    Все подрубрики
                                </Button>
                            )}
                        </Box>
                        <List sx={{ 
                            transition: 'all 0.3s ease-in-out',
                            opacity: isTransitioning ? 0.5 : 1 
                        }}>
                            {listItems}
                        </List>
                    </div>
                </Fade>
            );
        }

        return result;
    }, [selectedRubric, rubricHandle, goTo, isTransitioning]);

    const drawerList = useCallback(() => (
        <Box sx={{ width: getDrawerWidth() }} role="presentation">
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                sx={{
                    width: '100%',
                    margin: '0px 0px 16px 0px',
                    padding: '16px 16px 0 16px',
                }}
            >
                <img src="/images/sp/fedsp_logo.svg" loading="lazy" style={{ height: '20px' }} />
                <IconButton
                    aria-label="close"
                    onClick={toggleDrawer}
                    sx={{
                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                        color: 'rgba(0, 0, 0, 0.54)',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                            color: 'rgba(0, 0, 0, 0.7)',
                            transform: 'rotate(90deg)',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Stack>
            <Divider />
            <Slide direction="left" in={!isTransitioning} timeout={300}>
                <Box>
                    {listGenerator()}
                </Box>
            </Slide>
        </Box>
    ), [getDrawerWidth, toggleDrawer, listGenerator, isTransitioning]);

    return (
        <Fragment>
            <Backdrop 
                open={loader} 
                onClick={hideLoader} 
                sx={{ 
                    zIndex: 2147483647, 
                    color: '#fff',
                    transition: 'all 0.3s ease-in-out'
                }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Drawer 
                anchor="left" 
                variant="temporary" 
                open={open} 
                onClose={toggleDrawer}
                sx={{
                    '& .MuiDrawer-paper': {
                        transition: 'all 0.3s ease-in-out',
                        transform: open ? 'translateX(0)' : 'translateX(-100%)',
                    }
                }}
            >
                {drawerList()}
            </Drawer>
        </Fragment>
    );
};

export default App;
